import {default as Financeira} from './financeira/routes'
import {default as Localizacao} from './localizacao/routes'
import {default as OrigemContato} from './origem-contato/routes'
import {default as Servicos} from './servicos/routes'
import {default as TipoDevolucao} from './tipo-devolucao/routes'
import {default as Perito} from './perito/routes'
import {default as Reintegrador} from './reintegrador/reintegrador/routes'
import {default as ReintegradorRepresentante} from './reintegrador/representante/routes'
import {default as Seguradora} from './seguradora/routes'
import {default as OperadorDeEmpilhadeira} from './operador-empilhadeira/routes'
import {default as SituacaoApreensao} from './situacao-apreensao/routes'
import {default as TipoGrv} from './tipo-grv/routes'
import {default as TipoRemocao} from './tipo-remocao/routes'
import {default as Locadora} from './locadora/routes'
import {default as OperadoraReboque} from './operadora-reboque/operadora-reboque/routes'

export default [
  ...Financeira,
  ...Localizacao,
  ...OrigemContato,
  ...Servicos,
  ...TipoDevolucao,
  ...Perito,
  ...Reintegrador,
  ...ReintegradorRepresentante,
  ...Seguradora,
  ...OperadorDeEmpilhadeira,
  ...SituacaoApreensao,
  ...TipoGrv,
  ...TipoRemocao,
  ...Locadora,
  ...OperadoraReboque
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/routes.js